<template>
  <div class="checkbox-wrapper">
    <label class="label-checkbox" :class="{disabled: disabled}">
      <span class="label-checkbox__text" :for="value">{{ value }}</span>
      <input
        class="label-checkbox__input"
        :id="value"
        type="checkbox"
        :checked="checked"
        @change="onChange"
        :disabled="disabled"
      />
      <span class="label-checkbox__checkmark" />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    checked: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    onChange() {
      this.$emit('onSelect', this.value);
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox-wrapper {
  display: inline-block;
  white-space: nowrap;
}
.label-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  font-weight: var(--cta-btn-fw, bold);
  height: 30px;
  color: #2e2f38;
  background-color: var(--btn-gray-light-bg, #f1f1f1);
  border: 1px solid var(--btn-dark-grayed, #e6e6e6);
  display: flex;
  align-items: center;
  padding-left: 36px;
  padding-right: 10px;
  border-radius: 4px;
  &.disabled {
    color: var(--btn-grayed-f-color-active, darkgrey);
    background-color: var(--btn-grayed-bg-active, lightgray);
  }
  &:hover {
    cursor: pointer;
    color: var(--btn-grayed-f-color-active, darkgrey);
    background-color: var(--btn-grayed-bg-active, lightgray);
  }
  &__text {
    font-size: 12px;
    line-height: 14px;
  }
  &__input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &__checkmark {
    position: absolute;
    top: 2px;
    left: 3px;
    height: 24px;
    width: 24px;
    background-color: #fff;
    border-radius: 4px;
    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid #2e2f38;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}

.label-checkbox .label-checkbox__input:checked ~ .label-checkbox__checkmark:after {
  display: block;
}
</style>
